"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTMLModule = void 0;
const base_1 = require("./base");
class HTMLModule extends base_1.LabeledModule {
    constructor() {
        super(...arguments);
        this._type = "Html";
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            const builderConfigModule = {
                id: this.id,
                label: this.label,
                style: this.style,
                type: this.type,
            };
            if (this.tag) {
                builderConfigModule.tag = this.tag;
            }
            return builderConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        const _a = this.toBuilderConfig(), { label } = _a, rest = __rest(_a, ["label"]);
        return Object.assign(Object.assign({}, rest), { content: label[this.languageCode], actionRequired: this.actionRequired });
    }
    editProps() {
        return undefined;
    }
}
exports.HTMLModule = HTMLModule;
//# sourceMappingURL=Html.js.map